<template>
  <tr
    :class="{
      'red--text lighten-5 font-italic': report.Locked,
      'is-readonly': report.Status === 'C',
      'is-checked': checked && report.Status !== 'C'
    }"
  >
    <td
      class="report-item-col"
      v-for="(column, columnKey) in filteredColumns"
      :key="columnKey"
      :style="colStyles(column)"
      @contextmenu="showContext"
      @dblclick="onRowClick(report)"
    >
      <div
        class="cell-text-container py-1"
        :title="report[column.key]"
        :style="{
          'white-space': column.key === 'Description' ? 'pre-wrap': 'normal',
          'text-align': ['actions', 'Locked'].indexOf(column.key) > -1 ? 'center': 'left',
          'width': column.key === 'Locked' ? '100%': 'auto'
        }"
      >
        <template v-if="column.key === 'actions'">
          <v-checkbox
            v-model="checkedReport"
            dense
            hide-details
            class="ma-0 pa-0"
            :disabled="report.Status === 'C' || report.Locked"
          ></v-checkbox>
        </template>
        <template v-else-if="column.key === 'Locked'">
          <v-checkbox
            style="display: inline-block"
            v-model="report.Locked"
            dense
            hide-details
            class="pa-0 mx-auto my-0"
            :disabled="report.Status === 'C'"
            @change="onReportChanged"
          ></v-checkbox>
        </template>
        <template v-else-if="['Real_Dur', 'Report_Dur', 'Invoice_Dur'].indexOf(column.key) > -1">
          <div
            style="cursor: pointer"
            @click="(report.Status !== 'C' && !report.Locked) && toggleEditField(report, column.key)"
            v-if="showEditFields !== report.Reporting_ID + '_' + column.key"
          >
            {{ report[column.key] }}
          </div>
          <TimePicker
            v-else
            dense
            :showListOnMounted="true"
            v-model="report[column.key]"
            @change="onReportChanged"
          />
        </template>
        <template v-else>
          {{ report[column.key] | trimed }}
        </template>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'ReportItem',
  props: {
    value: {
      required: true
    },
    columns: {
      required: true
    },
    checked: {
      required: false
    }
  },
  components: {
    TimePicker: () => import('@/components/global/TimePicker.vue')
  },
  data () {
    return {
      showEditFields: ''
    }
  },
  computed: {
    filteredColumns () {
      return this.columns.filter(c => !c.hide)
    },
    checkedReport: {
      get () {
        return this.report.Status === 'U' && !this.report.Locked && this.checked
      },
      set (val) {
        if (val) {
          this.$emit('addSelectedReport', this.report.Reporting_ID)
        } else {
          this.$emit('removeSelectedReport', this.report.Reporting_ID)
        }
      }
    },
    report: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    widthStyle () {
      return width => {
        let widthStyle = ''
        if (width) {
          widthStyle = `
            width: ${width};
            max-width: ${width};
            min-width: ${width};
          `
        }
        return widthStyle
      }
    },
    colStyles () {
      return (col) => {
        return this.widthStyle(col.colWidth)
      }
    }
  },
  mounted () {
    this.checkedReport = false
  },
  filters: {
    trimed (val) {
      if (val && typeof val === 'string') {
        return val.trim()
      }
      return val
    }
  },
  methods: {
    toggleEditField (rep, colName) {
      if (this.showEditFields === rep.Reporting_ID + '_' + colName) {
        this.showEditFields = ''
      } else {
        this.showEditFields = rep.Reporting_ID + '_' + colName
      }
    },
    showContext (e) {
      e.preventDefault()
      this.$emit('onContextMenu', {
        show: true,
        x: e.clientX,
        y: e.clientY,
        report: this.report
      })
    },
    onRowClick (report) {
      this.$emit('rowClick', {
        report
      })
    },
    onReportChanged () {
      this.$store.dispatch('updateManagerReportState', { key: 'updateReport', value: this.report })
      this.showEditFields = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.report-item-col {
  overflow: hidden;
  padding: 0px 5px;
  font-size: 0.75rem;
  line-height: 0.75rem;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  transition: background-color 0.2s ease;

  &:last-child {
    border-right: none;
  }

  .theme--light & {
    color: rgba(0, 0, 0, 0.57) !important;
    border-right-color: rgba(0, 0, 0, 0.1);
    border-bottom-color: rgba(0, 0, 0, 0.1);
  }

  .theme--dark & {
    color: rgba(255, 255, 255, 0.7) !important;
    border-right-color: rgba(255, 255, 255, 0.1);
    border-bottom-color: rgba(255, 255, 255, 0.1);
  }
}

tr {
  height: 26px;
  background-color: #ffffff;

  .theme--dark & {
    background-color: #1e1e1e;
  }

  &.is-readonly {
    background-color: #ebeff2 !important;
    .theme--dark & { background-color: #2c2c2c !important; }
  }

  &.is-checked {
    background-color: #e0e6ed !important;
    .theme--dark & { background-color: #383838 !important; }
  }

  &:hover,
  &.red--text {
    .theme--light & {
      background-color: #d1d9de !important;
    }
    .theme--dark & {
      background-color: #424242 !important;
    }
  }

  &.red--text .report-item-col {
    color: #f44336 !important;
  }
}
</style>
